import { render, staticRenderFns } from "./CardTerapiasEnviadas.vue?vue&type=template&id=3b8b5491"
import script from "./CardTerapiasEnviadas.vue?vue&type=script&lang=js"
export * from "./CardTerapiasEnviadas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports